// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__ellipsi--result[data-v-4359dc5c] {\n  text-align: center;\n  max-width: 115px;\n  overflow: hidden;\n  transform: translateY(10px);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}", ""]);
// Exports
module.exports = exports;
